export const GTM_ID: string = process.env.REACT_APP_GTM_ID || '';

export const APP_ENV: string = process.env.REACT_APP_ENV || process.env.NODE_ENV || 'development';

export const isAnalyticsEnabled: boolean = Boolean(GTM_ID);

export const isAnalyticsDebug: boolean = APP_ENV !== 'production';
